import React from "react";

import {
  CopyLink,
  Facebook,
  WhatsApp,
} from "../../ShoppingList/SocialMediaSVGs";
export const ShareFooter = ({
  handleCopyLink,
  handleFacebookShare,
  handleWhatsappShare,
}) => {
  return (
    <div className="d-flex flex-column" style={{ gap: "4px" }}>
      <div
        style={{
          fontFamily: "Inter",
          fontWeight: 500,
          fontSize: "16px",
          lineHeight: "100%",
          letterSpacing: "0%",
          color: "black",
        }}
      >
        Share By
      </div>
      <div className="d-flex justify-content-center" style={{ gap: "16px" }}>
        <span style={{ cursor: "pointer" }} onClick={handleFacebookShare}>
          <Facebook />
        </span>
        <span style={{ cursor: "pointer" }} onClick={handleWhatsappShare}>
          <WhatsApp />
        </span>
        <span style={{ cursor: "pointer" }} onClick={handleCopyLink}>
          <CopyLink />
        </span>
      </div>
    </div>
  );
};
